import { Injectable } from '@angular/core';

import { LativHttpClient } from '@service/lativ.interceptor';
import { AuthService } from '@service/auth.service';
import {
  AddFavoriteRequest,
  DeleteFavoriteRequest,
  ListFavoritesResponse,
  MergeFavoritesRequest,
} from '@proto/store/api/store/misc/favorite/favorite';
import {
  AddStockReminderRequest,
  DeleteStockReminderRequest,
  ListStockRemindersResponse,
} from '@proto/store/api/store/misc/stock_reminder/stock_reminder';

import { map, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FavoriteRepositoryService {
  constructor(
    private http: LativHttpClient,
    private authService: AuthService
  ) {}

  // 收藏
  listFavorites(): Observable<ListFavoritesResponse> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(switchMap(() => this.http.get('v1/favorites').pipe(map(res => ListFavoritesResponse.fromJSON(res)))));
  }

  mergeFavorite(req: MergeFavoritesRequest): Observable<unknown> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(switchMap(() => this.http.post('v1/favorites:merge', MergeFavoritesRequest.toJSON(req))));
  }

  addFavorite(req: AddFavoriteRequest): Observable<unknown> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(
        switchMap(() =>
          this.http.put(AddFavoriteRequest.toJSON(req), `v1/favorites/${encodeURIComponent(req.productId)}`)
        )
      );
  }

  deleteFavorite(req: DeleteFavoriteRequest): Observable<unknown> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(switchMap(() => this.http.delete(`v1/favorites/${encodeURIComponent(req.productId)}`)));
  }

  clearFavorites(): Observable<unknown> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(switchMap(() => this.http.post('v1/favorites:clear', undefined)));
  }

  // 貨到通知
  listStockReminders(): Observable<ListStockRemindersResponse> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(
        switchMap(() => this.http.get('v1/stock_reminders').pipe(map(res => ListStockRemindersResponse.fromJSON(res))))
      );
  }

  addStockReminder(req: AddStockReminderRequest): Observable<unknown> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(
        switchMap(() =>
          this.http.put(AddStockReminderRequest.toJSON(req), `v1/stock_reminders/${encodeURIComponent(req.skuId)}`)
        )
      );
  }

  deleteStockReminder(req: DeleteStockReminderRequest): Observable<unknown> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(switchMap(() => this.http.delete(`v1/stock_reminders/${encodeURIComponent(req.skuId)}`)));
  }

  clearStockReminder(): Observable<unknown> {
    return this.authService
      .refreshTokenIfNeeded()
      .pipe(switchMap(() => this.http.post('v1/stock_reminders:clear', undefined)));
  }
}
